// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-expansion-panel[data-v-1e1c5ede] .v-expansion-panel-content__wrap {\r\n  padding: 0 !important;\n}\n.v-list-item[data-v-1e1c5ede] {\r\n  min-height: 0 !important;\n}\n.v-text-field[data-v-1e1c5ede] {\r\n  min-width: -webkit-fit-content;\r\n  min-width: -moz-fit-content;\r\n  min-width: fit-content;\n}\r\n\r\n/* .v-data-table::v-deep th {\r\n  border: solid 1px red;\r\n} */\r\n/* .row {\r\n  border: solid 1px red;\r\n}\r\n.col {\r\n  border: solid 1px orange;\r\n} */\r\n", ""]);
// Exports
module.exports = exports;
